const DpoDokument = {
    init: function () {
        const tlacitko = $("#tlacitkoGenerovatDokument");
        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function (e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    return;
                }
                DpoDokument.vygenerujDokument();
            });
    },

    vygenerujDokument: function () {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/dokument/zkontrolovatSablony";

        const titulId = $("#dotacnititul").val();
        if (!titulId) {
            return;
        }

        const sekceId = $('#idSection').val();
        if (!sekceId) {
            return;
        }
        url += '/' + sekceId;

        const zadostId = $('#idItem').val();
        if (!zadostId) {
            return;
        }
        url += '/' + zadostId;

        let postData = {"titulId": titulId};

        const _ch = $("#_ch");
        if (_ch.length) {
            postData["_ch"] = _ch.val();
        }

        $.ajax({
            type: "post",
            url: url,
            data: postData,
            dataType: "json",
            global: true,
            beforeSend: function () {
                Lemo_Alert.closeAll();
            },
            success: function (response) {
                if (response.hasOwnProperty('messages')) {
                    Lemo_Alert.addMany(response.messages);
                }

                if (true !== response.status) {
                    return;
                }

                if (1 === response.data["pocet"]) {
                    DpoDokument.generuj(response.data["sablonaId"]);
                } else if (response.data["pocet"] > 1 && null !== response.html) {
                    Lemo_Modal.setTitle("Šablona dokumentu");
                    Lemo_Modal.setContent(response.html);
                    Lemo_Modal.addButton('generate', translate('Generate'), 'btn btn-primary', function() {
                        DpoDokument.generuj($('#formTemplate').find('#sablona').val())
                        Lemo_Modal.close();
                    });
                    Lemo_Modal.addButton('cancel', 'Cancel', 'btn btn-default', function() {
                        Lemo_Modal.close();
                    });
                    Lemo_Modal.build();
                }
            },
            error: function () {
                Lemo_Alert.addDanger("Generování dokumentu selhalo.", "generovaniDokumentuError");
            }
        });
    },

    generuj: function (sablonaId) {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/dokument/vygenerovatDokument";

        const sekceId = $('#idSection').val();
        if (!sekceId) {
            return;
        }
        url += '/' + sekceId;

        const zadostId = $('#idItem').val();
        if (!zadostId) {
            return;
        }
        url += '/' + zadostId;

        let postData = {};
        const _ch = $("#_ch");
        if (_ch.length) {
            postData["_ch"] = _ch.val();
        }

        postData["sablonaId"] = sablonaId

        $.ajax({
            type: "post",
            url: url,
            data: postData,
            dataType: "json",
            global: true,
            beforeSend: function () {

            },
            success: function (r) {
                if (r.hasOwnProperty('messages')) {
                    Lemo_Alert.addMany(r["messages"]);
                }

                if (r.hasOwnProperty("status") && true === r["status"]) {
                    if (r.hasOwnProperty("data")) {
                        const data = r["data"];
                        if (data.hasOwnProperty("soubor")) {
                            url = window.location.protocol + "//" + window.location.host;
                            url += "/dpo/dokument/" + zadostId;
                            url += '/' + data["soubor"];
                            setTimeout(function () {
                                window.location = url;
                                Lemo_Alert.closeAll();
                            }, 1500);
                        }
                    }
                }
            },
            error: function () {
                Lemo_Alert.addDanger("Generování dokumentu selhalo.", "generovaniDokumentuError");
            }
        });
    }
}

$(document).ready(function () {
    DpoDokument.init();
});